import { BiHome } from "react-icons/bi";
import Img403 from "../../../assets/img/403img.png";
import Button from "../../../components/button/button";
import "./error403.scss";

export default function Error403() {
    return (
        <div className="error-page">
            <img src={Img403} className="error-page__img" alt="" />
            <h1 className="error-page__title">403 - Prohibido el acceso</h1>
            <p className="error-page__message">
                No tienes permiso para acceder a esta página. Si crees que esto
                es un error, contacta con una administradora.
            </p>
            <Button
                label="Volver al inicio"
                path="/"
                variant="filled"
                icon={<BiHome />}
            />
        </div>
    );
}
